import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Button, IconButton, Input, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchResultGrid from '../searchResultGrid/searchResultGrid';
import modalStyle from '../../styles/modalStyle';
import { caseColumnDef } from '../../colDef/caseColumnDef';
import apiClient from '../../axiosClient';
import Case from '../../interfaces/case';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import DropDownValue from '../baseComponents/dropdownvalue';
import { getCurrentMonthDateRange } from '../../utils/commonUtils';

interface CaseUpdateModalProps {
    open: boolean;
    onClose: () => void;
    selectedRows: Case[];
}

const AgentAllocationModal: React.FC<CaseUpdateModalProps> = ({ open, onClose, selectedRows }) => {
    const [agent, setAgent] = useState('');
    const [expiryDate, setExpiryDate ] = useState('');
    const userSlice = useSelector((state: RootState) => state.userList);
    const users = userSlice.users;
    const { todaysDate, endOfMonthDate } = getCurrentMonthDateRange();

    const handleSubmit = async () => {
        try {
            const body = selectedRows.map((row: Case) => {
                return {
                    client_reference_id: row.client_reference_id,
                    case_id: row.case_id,
                    agency_name: row.agency_name,
                    username: agent,
                    case_score: 0,
                    expiry_date: expiryDate,
                    client_name: row.client_name,
                }
            })
            const response = await apiClient.post('/api/v1/agent_case_allocation', body);
            if (response.status === 200) {
                alert("Agent Allocation successful");
            } else {
                alert("Agent Allocation failed");
            }
        } catch (error: any) {
            if (error.response) {
                alert('Error response data:' + error.response.data.message);
            } else if (error.request) {
                alert('No response received:' + error.request);
            } else {
                alert('Error message:' + error.message);
            }
        }
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography id="modal-title" variant="h6">
                        Add Agent Allocation
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, marginBottom: 2 }}>
                    <Box width={'100%'} sx={{ flex: '5 1 0%' }}>
                        <DropDownValue
                            label={"Select Agent Name for Allocation"}
                            multiple={false}
                            selectedValue={agent}
                            onSelection={(value) => setAgent(value)}
                            items={users || []}
                            valueProp={"username"}
                            displayProp={"username"}
                        />
                    </Box>
                </Box>


                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, marginBottom: 2 }}>
                    <Box width={'100%'} sx={{ flex: '5 1 0%' }}>
                        <TextField
                            type="date"
                            onChange={e =>setExpiryDate(e.target.value)}
                            fullWidth
                            value={expiryDate}
                            label={"Select Expiry Date"}
                            slotProps={{
                                inputLabel: { shrink: true },
                                htmlInput: {
                                    min: todaysDate,
                                    max: endOfMonthDate
                                }
                            }}
                        />
                    </Box>
                </Box>         

                <Box mt={3}>
                    <Typography variant="subtitle1">Selected Rows:</Typography>
                    <SearchResultGrid
                        getRowId={(row) => row.case_id}
                        results={selectedRows}
                        onSelectRow={() => { }}
                        columns={caseColumnDef}
                        isRowSelectionAllowed={false}
                    />
                </Box>

                <Box mt={3} textAlign="right">
                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={agent.trim() === "" || expiryDate.trim() === ""} >Submit</Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default AgentAllocationModal;
